import { SVGProps } from 'react';

export const PauseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='7'
    height='10'
    viewBox='0 0 7 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.8743e-07 0.5C3.8743e-07 0.223858 0.223858 0 0.5 0H1.5C1.77614 0 2 0.223858 2 0.5V9.5C2 9.77614 1.77614 10 1.5 10H0.5C0.367392 10 0.240215 9.94732 0.146447 9.85355C0.0526784 9.75979 0 9.63261 0 9.5L3.8743e-07 0.5ZM5 0.5C5 0.223858 5.22386 0 5.5 0H6.5C6.63261 0 6.75979 0.0526784 6.85355 0.146447C6.94732 0.240215 7 0.367392 7 0.5L7 9.5C7 9.77614 6.77614 10 6.5 10H5.5C5.22386 10 5 9.77614 5 9.5V0.5Z'
    />
  </svg>
);
